<!--suppress ALL -->

<template>
  <div>
<!--    <Upload ref="upload" :action="this.$fileUploadPath" name="file"-->
<!--            :before-upload="handleBeforeUpload" :show-upload-list="true" :on-format-error="handleFormatError"-->
<!--            :on-success="handleSuccess" :on-error="handleError" :format="[]">-->
<!--      <Button type="default" icon="ios-cloud-upload-outline" style="">选择文件</Button>-->
<!--    </Upload>-->

    <el-upload
      ref="upload"
      :action="metaData ? this.$fileUploadPathMeta:this.$fileUploadPath"
      name="file"
      :before-upload="handleBeforeUpload"
      :show-file-list="!hideNameView"
      :on-success="handleSuccess"
      :accept="accept"
      :multiple="multiple"
    >
      <img v-if="customIcon" style="margin-bottom: -2px;" src="@/assets/box_file.png" width="20px" height="20px"/>
      <el-button v-if="!customIcon" type="default" icon="el-icon-upload2">{{uploadText}}</el-button>
    </el-upload>


    <div v-if="originFileRequire && fileNameView && !hideNameView" style="margin-top: 10px">
      {{ fileNameView }}
      <el-button size="small" type="text"  @click="fileNameViewDelect">删除</el-button>
    </div>
  </div>
</template>


<script>

export default {
  name: 'FileUpload',
  props: {
    originFileRequire: {
      type: Boolean,
      default: false
    },
    metaData: {
      type: Boolean,
      default: false
    },
    hideNameView: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    customIcon: {
      type: String,
      default: ''
    },
    uploadText: {
      type: String,
      default: '上传文件'
    },
    accept: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      fileNameView: '',
    }
  },

  methods: {

    fileNameViewDelect() {
      this.fileNameView = ''
    },

    handleBeforeUpload(file) {
      console.log(this.size)
      if (this.size > 0){
        const less = file.size < this.size;
        console.log()
        if (!less) {
          this.$message.error('上传文件大小超过限制');
        }
        return less;
      }
      // 在这里你可以直接操作原始文件
      console.log('原始文件:', file)
      this.originFile = file
      this.fileNameView = file.name
      if (this.originFileRequire){
        this.$emit('upload-success',  this.originFile);
        return false;
      }
      return true
    },

    handleFormatError(file) {
      this.$Notice.warning({
        title: '文件格式不正确',
        desc: '文件 ' + file.name + ' 格式不正确'
      })
    },
    handleSuccess(res, file) {
      //console.log(res)
      //console.log(file)
      if (res.status === 1) {
        this.$emit('upload-success',  res.data.url, file.name, res.data);
      } else {
        this.$Message.error(res.errorMsg)
      }
    },
    handleError(error, file) {
      this.$Message.error('上传失败！')
    },

  }

}
</script>
<style scoped >
@import '../assets/global.css';
</style>
